import React, { CSSProperties, useContext } from 'react';
import styles from './style.less';
import { Divider } from 'antd';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { IS_POS } from '@/utils/env';

type Props = {
  children: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  desc?: React.ReactNode;
  actions?: React.ReactNode;
  ghost?: boolean;
  fullSize?: boolean;
  fullFill?: boolean;
  size?: 'small' | 'default' | 'xs';
  style?: CSSProperties;
  header?: React.ReactNode;
  ghostFull?: boolean;
};

const Block: React.FC<Props> = ({
  style = {},
  children,
  ghost = false,
  ghostFull = false,
  fullSize = false,
  fullFill = false,
  size = 'default',
  title,
  actions,
  subTitle,
  desc,
  className = '',
  header,
}: Props) => {
  if (ghostFull) {
    ghost = true;
    fullSize = true;
  }

  return (
    <div
      style={style}
      className={`${className} ${styles.block} ${styles[`size-${size}`]} ${
        ghost ? styles.ghost : ''
      } ${fullSize ? styles.fullSize : ''} ${fullFill ? styles.fullFill : ''} ${IS_POS ? styles.pos : ''}`}>
      {header ? header : null}
      {title ? (
        <div className={styles.titleWrapper}>
          <div className={styles.titleLeft}>
            <Divider orientation={'left'} className={`${desc ? styles.hasDesc : ''} ${styles.title}`}>
              {title} {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
            </Divider>
          </div>
          {actions && <div className={styles.titleRight}>{actions}</div>}
        </div>
      ) : null}
      {desc && <div className={styles.desc}>{desc}</div>}
      {children}
    </div>
  );
};

export default Block;
